import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { dataHooks } from 'wix-style-react-tpa/dist/src/Slider/constants';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { errorMessageWrapperDriverFactory } from '../internal/ErrorMessageWrapper/ErrorMessageWrapper.driver';
import { RangeDataHooks } from './types';

export interface RangeDriver extends BaseUniDriver {
  handle: (index?: number) => UniDriver<any>;
  getMinValue(): Promise<number>;
  getMaxValue(): Promise<number>;
  getSelectedValue(): Promise<number[]>;
  getLabelText(): Promise<string>;
  getErrorMessage(): Promise<string>;
}

export const rangeDriverFactory = (base: UniDriver): RangeDriver => {
  const getHandle = (index = 0) =>
    base.$$(`[data-hook="${dataHooks.sliderHandle}"]`).get(index);

  return {
    ...baseUniDriverFactory(base),
    handle: getHandle,
    getMinValue: async () => {
      const minValue = await getHandle(0).attr('aria-valuemin');
      return parseFloat(minValue);
    },
    getMaxValue: async () => {
      const maxValue = await getHandle(0).attr('aria-valuemax');
      return parseFloat(maxValue);
    },
    getSelectedValue: async () => {
      const selectedMinValue = await getHandle(0).attr('aria-valuenow');
      const selectedMaxValue = await getHandle(1).attr('aria-valuenow');

      return [parseInt(selectedMinValue, 10), parseInt(selectedMaxValue, 10)];
    },
    getLabelText: async () => {
      return base.$(`[data-hook="${RangeDataHooks.Label}"]`).text();
    },
    getErrorMessage: async () => {
      const errorMessageWrapperDriver = errorMessageWrapperDriverFactory(base);

      return errorMessageWrapperDriver.getErrorMessage();
    },
  };
};
